import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";
import { Observable } from "rxjs";

import { AccountSettingPhoneValidation } from "./account-settings.model";

@Injectable({
	providedIn: "root",
})
export class AccountSettingsConfigService {
	constructor(
		private configService: ConfigService<ObgConfigFeAdaptiveClientCore & ObgConfigFeAdaptiveClientCommon>
	) {}

	getChangePasswordDisabled(): boolean {
		return this.configService.get((x) => x.common.accountSettings.changePasswordDisabled, false);
	}

	getChangePasswordEndpoint(): string {
		return this.configService.get((x) => x.core.auth.endpoints!.changePassword, "v1/credentials/up/:username/");
	}

	getChangeAddressDisabled(): boolean {
		return this.configService.get((x) => x.common.accountSettings.changeAddressDisabled, false);
	}

	/**
	 * This config is under jurisdiction
	 */
	getChangeProfileEnabled(): boolean {
		return this.configService.get((x) => x.common.accountSettings.changeProfileEnabled, false);
	}

	getChangeFullProfileEnabled(): boolean {
		return this.configService.get((x) => x.common.accountSettings.changeFullProfileEnabled, false);
	}

	getPhoneNumberValidation(): AccountSettingPhoneValidation {
		return this.configService.get((x) => x.common.accountSettings.defaultPhoneValidationSettings, {
			min: 6,
			max: 15,
		});
	}

	getKycVerifiedProfileEditDisabled(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.common.accountSettings.kycVerifiedProfileEditDisabled, false);
	}

	getPreferencesSettings() {
		return this.configService.get((x) => x.common.accountSettings.preferencesSettings, []);
	}

	getCloseAccountDisabled(): boolean {
		return this.configService.get((x) => x.common.accountSettings.closeAccountDisabled, true);
	}

	getShowPhoneNumberFieldOnLatamMarkets(): Observable<string[] | undefined> {
		return this.configService.get$(
			(config) => config.common.accountSettings.showPhoneNumberFieldOnLatamMarkets,
			[]
		);
	}

	/**
	 * @todo Consider deprecating this, as we now use `authentication-actions` to determine whether Facial Recognition should be displayed.
	 */
	getFacialRecognitionEnabled(): boolean {
		return this.configService.get((x) => x.common.accountSettings.facialRecognitionEnabled, false);
	}
}
